/*
 * Naturepride — pagina prodotto
 * Selettore varianti (pillole con €/kg), quantità, aggiunta al carrello AJAX,
 * galleria con swipe, miniature e lightbox, barra acquisto mobile.
 */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(c) { return window.NP && window.NP.formatMoney ? window.NP.formatMoney(c) : (c / 100).toFixed(2); }

  function Product(root) {
    this.root = root;
    try { this.data = JSON.parse($('[data-np-product-json]', root).textContent); } catch (e) { return; }
    this.variants = this.data.variants || [];
    var id = parseInt($('[data-np-variant-id]', root).value, 10);
    this.current = this.variants.filter(function (v) { return v.id === id; })[0] || this.variants[0];
    this.options = this.current ? this.current.options.slice() : [];
    this.qty = 1;
    this.initVariants();
    this.initQty();
    this.initForm();
    this.initGallery();
    this.initLightbox();
    this.initBar();
    this.initAbroad();
    this.refreshAvailability();
  }

  /* ------------------------------------------------------------ varianti */

  Product.prototype.initVariants = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-np-variant]');
      if (pill) {
        var id = parseInt(pill.getAttribute('data-np-variant'), 10);
        var v = self.variants.filter(function (x) { return x.id === id; })[0];
        if (v) { self.options = v.options.slice(); self.select(v); }
        return;
      }
      var opt = e.target.closest('[data-np-option]');
      if (opt) {
        var idx = parseInt(opt.getAttribute('data-np-option'), 10);
        self.options[idx] = opt.getAttribute('data-value');
        var match = self.find(self.options);
        if (!match) {
          /* combinazione inesistente: prendi la prima variante con il valore scelto */
          match = self.variants.filter(function (x) { return x.options[idx] === self.options[idx] && x.available; })[0] ||
                  self.variants.filter(function (x) { return x.options[idx] === self.options[idx]; })[0];
          if (match) self.options = match.options.slice();
        }
        self.select(match || null);
      }
    });
  };

  Product.prototype.find = function (opts) {
    return this.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    })[0];
  };

  Product.prototype.refreshAvailability = function () {
    var self = this;
    $$('[data-np-option]', this.root).forEach(function (b) {
      var idx = parseInt(b.getAttribute('data-np-option'), 10);
      var val = b.getAttribute('data-value');
      var on = self.options[idx] === val;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var ok = self.variants.some(function (v) {
        if (!v.available || v.options[idx] !== val) return false;
        for (var i = 0; i < idx; i++) { if (v.options[i] !== self.options[i]) return false; }
        return true;
      });
      b.classList.toggle('is-na', !ok);
    });
    $$('[data-np-opt-selected]', this.root).forEach(function (el) {
      var i = parseInt(el.getAttribute('data-np-opt-selected'), 10);
      el.textContent = self.options[i] || '';
    });
  };

  Product.prototype.select = function (v) {
    var root = this.root;
    var labels = this.data.labels;
    this.current = v;

    $$('[data-np-variant]', root).forEach(function (b) {
      var on = v && b.getAttribute('data-np-variant') === String(v.id);
      b.classList.toggle('is-on', !!on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    this.refreshAvailability();

    var submit = $('[data-np-submit]', root);
    var submitText = $('[data-np-submit-text]', root);
    var barAdd = $('[data-np-bar-add]', root);
    var idInput = $('[data-np-variant-id]', root);

    if (!v) {
      if (submit) submit.disabled = true;
      if (barAdd) barAdd.disabled = true;
      if (submitText) submitText.textContent = labels.unavailable;
      this.setStock('is-out', labels.unavailable);
      return;
    }

    if (idInput) idInput.value = v.id;

    var price = $('[data-np-price]', root);
    var compare = $('[data-np-compare]', root);
    var save = $('[data-np-save]', root);
    var saveN = $('[data-np-save-n]', root);
    var unit = $('[data-np-unit]', root);
    var discount = v.compare > v.price ? Math.round((v.compare - v.price) * 100 / v.compare) : 0;

    if (price) price.textContent = money(v.price);
    if (compare) { compare.hidden = !discount; compare.textContent = discount ? money(v.compare) : ''; }
    if (save) save.hidden = !discount;
    if (saveN) saveN.textContent = discount;
    var flag = $('[data-np-stage-flag]', root);
    if (flag) { flag.hidden = !discount; flag.textContent = '-' + discount + '%'; }
    if (unit) { unit.textContent = v.unit || ''; unit.hidden = !v.unit; }

    var factUnit = $('[data-np-fact-unit]', root);
    if (factUnit) { factUnit.hidden = !v.unit; $('[data-np-unit-text]', factUnit).textContent = v.unit || ''; }
    var factSku = $('[data-np-fact-sku]', root);
    if (factSku) { factSku.hidden = !v.sku; $('[data-np-sku]', factSku).textContent = v.sku || ''; }

    if (!v.available) this.setStock('is-out', labels.outStock);
    else if (v.qty !== null && v.qty > 0 && v.qty <= this.data.lowThreshold) this.setStock('is-low', labels.lowStock.replace('[count]', v.qty));
    else this.setStock('', labels.inStock);

    if (submit) submit.disabled = !v.available;
    if (barAdd) barAdd.disabled = !v.available;
    this.updateTotals();

    var bar = $('[data-np-bar-price]', root);
    if (bar) bar.textContent = money(v.price);

    if (v.media) this.goToMedia(v.media);

    var url = new URL(location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState(history.state, '', url.toString());
  };

  Product.prototype.setStock = function (cls, text) {
    var el = $('[data-np-stock]', this.root);
    if (!el) return;
    el.classList.remove('is-out', 'is-low');
    if (cls) el.classList.add(cls);
    $('[data-np-stock-text]', el).textContent = text;
  };

  Product.prototype.updateTotals = function () {
    var v = this.current;
    var submitText = $('[data-np-submit-text]', this.root);
    if (!v) return;
    if (submitText) {
      if (v.available) {
        submitText.innerHTML = '';
        submitText.appendChild(document.createTextNode(this.data.labels.add + ' · '));
        var t = document.createElement('span');
        t.className = 'np-num';
        t.setAttribute('data-np-total', '');
        t.textContent = money(v.price * this.qty);
        submitText.appendChild(t);
      } else {
        submitText.textContent = this.data.labels.soldOut;
      }
    }
    this.syncAbroad();
    var fs = $('[data-np-freeship]', this.root);
    if (fs && window.NP && window.NP.updateFreeship) {
      fs.setAttribute('data-extra', v.price * this.qty);
      window.NP.updateFreeship(parseInt(fs.getAttribute('data-cart'), 10) || 0);
    }
  };

  /* ------------------------------------------------------------ quantità e carrello */

  Product.prototype.initQty = function () {
    var self = this;
    var input = $('[data-np-qty-input]', this.root);
    if (!input) return;
    function set(n) {
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      self.qty = n;
      input.value = n;
      self.updateTotals();
    }
    $$('[data-np-qty]', this.root).forEach(function (b) {
      b.addEventListener('click', function () { set(self.qty + parseInt(b.getAttribute('data-np-qty'), 10)); });
    });
    input.addEventListener('change', function () { set(input.value); });
  };

  Product.prototype.initForm = function () {
    var self = this;
    var form = $('[data-np-form]', this.root);
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (!window.NP || !window.NP.addToCart || !self.current) return;
      e.preventDefault();
      var btn = $('[data-np-submit]', self.root);
      var bar = $('[data-np-bar-add]', self.root);
      [btn, bar].forEach(function (b) { if (b) { b.disabled = true; b.classList.add('is-busy'); } });
      window.NP.addToCart([{ id: self.current.id, quantity: self.qty }])
        .catch(function (err) { window.NP.toast(err.message, true); })
        .then(function () {
          [btn, bar].forEach(function (b) { if (b) { b.classList.remove('is-busy'); b.disabled = !self.current.available; } });
        });
    });
    document.addEventListener('np:cart:updated', function (e) {
      var fs = $('[data-np-freeship]', self.root);
      if (fs && e.detail && e.detail.cart) {
        fs.setAttribute('data-cart', e.detail.cart.total_price);
        self.updateTotals();
      }
    });
  };

  /* ------------------------------------------------------------ galleria */

  Product.prototype.initGallery = function () {
    var self = this;
    var track = $('[data-np-track]', this.root);
    if (!track) return;
    this.track = track;
    var slides = $$('.np-slide', track);
    var thumbs = $$('[data-np-thumb]', this.root);
    var count = $('[data-np-count]', this.root);
    var prev = $('[data-np-step="-1"]', this.root);
    var next = $('[data-np-step="1"]', this.root);
    this.index = 0;

    function mark(i) {
      self.index = i;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      var t = thumbs[i];
      if (t && t.parentNode.scrollHeight > t.parentNode.clientHeight + 2) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      $$('video', track).forEach(function (vid, k) { if (!slides[i].contains(vid)) vid.pause(); });
    }
    this.goTo = function (i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      mark(i);
    };

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== self.index) mark(i);
      });
    }, { passive: true });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.goTo(parseInt(t.getAttribute('data-np-thumb'), 10)); });
    });
    $$('[data-np-step]', this.root).forEach(function (b) {
      b.addEventListener('click', function () { self.goTo(self.index + parseInt(b.getAttribute('data-np-step'), 10)); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') self.goTo(self.index + 1);
      if (e.key === 'ArrowLeft') self.goTo(self.index - 1);
    });

    /* immagine della variante selezionata all'apertura */
    if (this.current && this.current.media && /[?&]variant=/.test(location.search)) this.goToMedia(this.current.media, true);
    else mark(0);
  };

  Product.prototype.goToMedia = function (mediaId, instant) {
    if (!this.track || !this.goTo) return;
    var slide = $('[data-media-id="' + mediaId + '"]', this.track);
    if (slide) this.goTo(parseInt(slide.getAttribute('data-index'), 10), instant);
  };

  /* ------------------------------------------------------------ lightbox */

  Product.prototype.initLightbox = function () {
    var dialog = $('[data-np-lightbox]', this.root);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var track = $('[data-np-lightbox-track]', dialog);
    this.root.addEventListener('click', function (e) {
      var z = e.target.closest('[data-np-zoom]');
      if (!z) return;
      var i = z.getAttribute('data-np-zoom');
      $$('img[data-src]', dialog).forEach(function (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); });
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      var li = $('li[data-index="' + i + '"]', track);
      if (li) track.scrollLeft = li.offsetLeft;
    });
    function close() { dialog.close(); }
    $('[data-np-lightbox-close]', dialog).addEventListener('click', close);
    dialog.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    track.addEventListener('click', function (e) { if (e.target.tagName !== 'IMG') close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      if (e.key === 'ArrowLeft') track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
  };

  /* ------------------------------------------------------------ spedizione fuori Malta */

  var COUNTRY_KEY = 'np-country';

  function detectCountry() {
    try {
      var cached = sessionStorage.getItem(COUNTRY_KEY);
      if (cached) return Promise.resolve(cached);
    } catch (e) { /* storage bloccato */ }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (json) {
        var c = json && json.detected_values && json.detected_values.country;
        var code = c && (c.handle || c.iso_code) ? String(c.handle || c.iso_code).toUpperCase() : '';
        try { if (code) sessionStorage.setItem(COUNTRY_KEY, code); } catch (e) { /* noop */ }
        return code;
      })
      .catch(function () { return ''; });
  }

  function countryName(code) {
    try { return new Intl.DisplayNames(['en'], { type: 'region' }).of(code); } catch (e) { return ''; }
  }

  Product.prototype.initAbroad = function () {
    var self = this;
    var box = $('[data-np-abroad]', this.root);
    if (!box) return;
    this.abroad = box;
    var panel = $('[data-np-abroad-panel]', box);
    var home = (box.getAttribute('data-home') || 'MT').split(',').filter(Boolean);
    var liquidCountry = (box.getAttribute('data-country') || '').toUpperCase();
    var qtyField = $('[data-np-abroad-qty]', box);
    if (qtyField) qtyField.addEventListener('input', function () { qtyField.__touched = true; });

    /* dopo l'invio Shopify ricarica la pagina con ?contact_posted=true: mostra la conferma */
    var posted = /[?&]contact_posted=true/.test(location.search) || $('[data-np-abroad-ok]', box) || $('.np-abroad__err', box);
    if (posted && panel) {
      panel.open = true;
      setTimeout(function () { box.scrollIntoView({ block: 'center' }); }, 150);
    }

    function apply(code) {
      if (!code) return;
      var field = $('[data-np-abroad-detected]', box);
      if (field) field.value = code;
      if (home.indexOf(code) !== -1) return;
      box.classList.add('is-abroad');
      self.root.classList.add('np-abroad-foreign');
      if (box.getAttribute('data-hide-buy') === 'true') self.root.classList.add('np-abroad-mode');
      if (box.getAttribute('data-open') === 'true' && panel) panel.open = true;
      var select = $('[data-np-abroad-country]', box);
      var name = countryName(code);
      if (select && !select.value && name) {
        var opt = Array.prototype.filter.call(select.options, function (o) { return o.value === name || o.textContent.trim() === name; })[0];
        if (opt) select.value = opt.value;
      }
    }

    if (liquidCountry && home.indexOf(liquidCountry) === -1) apply(liquidCountry);
    else detectCountry().then(apply);

    if (panel) panel.addEventListener('toggle', function () { if (panel.open) self.syncAbroad(); });
    this.syncAbroad();
  };

  Product.prototype.syncAbroad = function () {
    var box = this.abroad;
    var v = this.current;
    if (!box || !v) return;
    var label = v.options && v.options.length && v.options.join(' / ') !== 'Default Title' ? v.options.join(' / ') : '';
    var set = function (sel, val) { var el = $(sel, box); if (el) el.value = val; };
    set('[data-np-abroad-variant]', label || '-');
    set('[data-np-abroad-sku]', v.sku || '');
    set('[data-np-abroad-price]', money(v.price));
    var url = $('[data-np-abroad-url]', box);
    if (url) url.value = url.value.split('?')[0] + (label ? '?variant=' + v.id : '');
    var forV = $('[data-np-abroad-for-variant]', box);
    if (forV) forV.textContent = label ? ' · ' + label : '';
    var qty = $('[data-np-abroad-qty]', box);
    if (qty && !qty.__touched) qty.value = this.qty || 1;
  };

  /* ------------------------------------------------------------ barra mobile */

  Product.prototype.initBar = function () {
    var bar = $('[data-np-bar]', this.root);
    var target = $('[data-np-submit]', this.root);
    if (!bar || !target) return;
    bar.hidden = false;
    var form = $('[data-np-form]', this.root);
    $('[data-np-bar-add]', bar).addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
    if (!('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.np-footer, footer');
    var aboveFold = true;
    var footerVisible = false;
    function sync() { bar.classList.toggle('is-on', !aboveFold && !footerVisible); }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { aboveFold = en.isIntersecting || en.boundingClientRect.top > 0; });
      sync();
    }).observe(target);
    if (footer) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { footerVisible = en.isIntersecting; });
        sync();
      }).observe(footer);
    }
  };

  function init() {
    $$('[data-np-product]').forEach(function (root) {
      if (!root.__np) root.__np = new Product(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
